import { getGrossVerticalArea as n } from "./index.js";
function a(e) {
  const t = n(e);
  return e.children.length > 0 ? t - e.children.map((r) => a(r)).reduce((r, c) => r + c, 0) : t;
}
export {
  a as getNetVerticalArea
};
//# sourceMappingURL=index6.js.map
